import { createVNode, resolveComponent, defineComponent, computed } from 'vue';
export default defineComponent({
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    },
    class: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: '#000'
    }
  },
  setup(props) {
    const iconStyle = computed(() => {
      const {
        size,
        color
      } = props;
      const s = `${size.replace('px', '')}px`;
      return {
        fontSize: s,
        color: color
      };
    });
    if (props.name.indexOf('el-icon-') === 0) {
      return () => createVNode('el-icon', {
        class: [props.class, 'icon el-icon'],
        style: iconStyle.value
      }, [createVNode(resolveComponent(props.name))]);
    } else {
      return () => createVNode('i', {
        class: [props.name, props.class, 'icon'],
        style: iconStyle.value
      });
    }
  }
});